import { OpmetReportWidgetConfiguration } from "@/lib/api";
import HTML from "@/features/shared/widgets/html/html";
import useRefreshWidget from "@/features/shared/widgets/hooks/useRefetchWidget";
import { useTranslation } from "@/lib/i18n";

const OpmetReport = ({
  id,
  data,
  configuration,
}: {
  id: string;
  data: string;
  configuration: OpmetReportWidgetConfiguration;
}) => {
  const { t } = useTranslation();
  useRefreshWidget(id);

  if (!data && configuration?.report_type) {
    return (
      <div>
        {t(
          `widgets.opmet.no_data.${configuration.report_type}` as "widgets.opmet.no_data.metar",
        )}
      </div>
    );
  }

  return <HTML id={id} data={data} />;
};

export default OpmetReport;
